/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'floor': {
    width: 13,
    height: 13,
    viewBox: '0 0 13 13',
    data: '<path pid="0" _fill="#F7B500" d="M6.45.003a.414.414 0 00-.153.053L.232 3.46A.47.47 0 000 3.87c0 .173.09.332.232.412l1.61.904-1.61.904A.47.47 0 000 6.5c0 .173.09.331.232.412l1.61.904-1.61.905A.47.47 0 000 9.13c0 .173.09.331.232.411l6.065 3.404a.406.406 0 00.405 0l6.066-3.404a.47.47 0 00.232-.41.47.47 0 00-.232-.411l-1.612-.905 1.612-.904A.47.47 0 0013 6.5a.47.47 0 00-.232-.411l-1.612-.904 1.612-.904A.47.47 0 0013 3.87a.47.47 0 00-.232-.411L6.702.056A.408.408 0 006.45.003zm.05.99l5.13 2.877L6.5 6.748 1.369 3.87 6.499.994zM2.776 5.709l3.52 1.978a.406.406 0 00.406 0l3.52-1.978 1.408.793L6.5 9.378 1.369 6.5l1.407-.793v.001zm0 2.63l3.52 1.978a.406.406 0 00.406 0l3.52-1.978 1.408.793-5.13 2.877L1.369 9.13l1.407-.793z"/>'
  }
})
